import validUrl from 'valid-url'

export default {
  validate (val) {
    return !!validUrl.isWebUri(val)
  }
}
